import {
  Download1Stroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import { format } from 'date-fns';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { formatDate } from '@/lib/formatUtils';

interface SearchParams {
  ngay_ct?: string;
  account?: {
    code?: string;
    name?: string;
  };
}

interface ActionBarProps {
  onSearchClick?: () => void;
  onRefreshClick?: () => void;
  onPrintClick?: () => void;
  onFixedColumnsClick?: () => void;
  onExportDataClick?: () => void;
  onEditPrintTemplateClick?: () => void;
  className?: string;
  searchParams?: SearchParams;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onSearchClick,
  onRefreshClick,
  onPrintClick,
  onFixedColumnsClick,
  onExportDataClick,
  onEditPrintTemplateClick,
  className,
  searchParams
}) => {
  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Báo cáo số dư công nợ</h1>
          {searchParams && searchParams.ngay_ct && searchParams.account && (
            <div className='text-[10px] text-gray-500'>
              <p>
                <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
                {searchParams.account && (
                  <span className='font-semibold'>Tài khoản: [{searchParams.account.code}]</span>
                )}
                {searchParams.ngay_ct && (
                  <span className='font-semibold'> - Ngày {formatDate(searchParams.ngay_ct)}</span>
                )}
              </p>
            </div>
          )}
        </div>
      }
    >
      {onSearchClick && (
        <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick} variant='primary' />
      )}
      {onSearchClick && <ActionButtonV2 icon={PrinterStroke} title='In ấn' onClick={onPrintClick} variant='primary' />}
      {/* No print button */}
      {onRefreshClick && (
        <ActionButtonV2
          icon={RefreshCircle1ClockwiseStroke}
          title='Refresh'
          onClick={onRefreshClick}
          variant='destructive'
        />
      )}
      {onFixedColumnsClick && (
        <ActionButtonV2
          icon={SignPostLeftStroke}
          title='Cố định cột'
          onClick={onFixedColumnsClick}
          variant='secondary'
        />
      )}
      {onExportDataClick && (
        <ActionButtonV2
          icon={Download1Stroke}
          title='Kết xuất dữ liệu'
          onClick={onExportDataClick}
          variant='secondary'
        />
      )}
      <MenuButtonV2
        items={[
          {
            title: 'Chỉnh sửa mẫu in',
            icon: <AritoIcon icon={864} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
